module.exports = __WEBPACK_EXTERNAL_MODULE_5__;


//////////////////
// WEBPACK FOOTER
// external "element-ui/lib/theme-chalk/base.css"
// module id = 5
// module chunks = 0 1 2